<i *ngIf="showIcon"
   class="pe-1 align-self-baseline fal fa-lock-alt"></i>
<ng-container *ngIf="role">
    <a *ngIf="!linkDisabled; else noLink"
       class="btn btn-link"
       (click)="configureAccessLevel()">{{role!.label}}</a>

    <ng-template #noLink>{{role!.label}}</ng-template>
</ng-container>
